import { render } from "./Catalogo.vue?vue&type=template&id=b7b95512"
import script from "./Catalogo.vue?vue&type=script&lang=js"
export * from "./Catalogo.vue?vue&type=script&lang=js"
script.render = render

export default script